import PropTypes from 'prop-types'
import InputLabel from '../ui/InputLabel'

const FechaPublicacion = ({
  valueDesde,
  valueHasta,
  disabledDesde,
  onChange,
  vieneDeAdministrar
}) => {
  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Indica desde qué fecha quieres que tu producto esté disponible al público.
        </p>
      )}
      <div className="row d-none d-md-block">
        <div className="col mb-3">
          <InputLabel
            type="date"
            name="desde"
            value={valueDesde}
            classNameInput="input-text-bordered w-40"
            onChange={onChange}
            label="Fecha desde: "
            error="Completar Fecha desde"
            disabled={disabledDesde ? disabledDesde : false}
          />
        </div>
        <div className="col">
          <InputLabel
            type="date"
            name="hasta"
            value={valueHasta}
            classNameInput="input-text-bordered w-40"
            onChange={onChange}
            label="Fecha hasta: "
            error="Completar Fecha hasta"
          />
        </div>
        {vieneDeAdministrar && <div className="col" />}
      </div>
      <div className="row d-block d-md-none">
        <div className="col-12">
          <InputLabel
            type="date"
            name="desde"
            value={valueDesde}
            classNameInput="input-text-bordered w-30"
            onChange={onChange}
            label="Fecha desde: "
            error="Completar Fecha desde"
            disabled={disabledDesde ? disabledDesde : false}
          />
        </div>
        <div className="col-12">
          <InputLabel
            type="date"
            name="hasta"
            value={valueHasta}
            classNameInput="input-text-bordered w-30"
            onChange={onChange}
            label="Fecha hasta: "
            error="Completar Fecha hasta"
          />
        </div>
        {vieneDeAdministrar && <div className="col" />}
      </div>
    </>
  )
}

FechaPublicacion.propTypes = {
  valueDesde: PropTypes.string,
  valueHasta: PropTypes.string,
  disabledDesde: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default FechaPublicacion
